module.exports = __webpack_public_path__ + "static/media/tq.307cad37.png";